/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseCategoryCardGridFragment} from '@amblique/contentful/app/contentful/fragments/category-card-grid/base-category-card-grid.fragment';
import {BaseCardFragment} from '@amblique/contentful/app/contentful/fragments/card/base-card.fragment';

export const CategoryCardGridFragment = gql`
  ${BaseCardFragment}
  ${BaseCategoryCardGridFragment}

  fragment CategoryCardGridFragment on CategoryCardGrid {
    ...BaseCategoryCardGridFragment

    cardItemsCollection {
      items {
        __typename
        ... on Card {
          ...BaseCardFragment
        }
      }
    }
    cardItemsCursorCollection {
      items {
        __typename
        ... on Card {
          ...BaseCardFragment
        }
      }
    }
  }
`;
